import React, { useState, useEffect } from 'react'
//import {getStudentIdData } from "../../../../lib/studentlessonsfortranskriptview"
//import { getStudentIdData as getStudentLessons } from "../../../../lib/studentlessonsfortranskriptview"
import {
  getStudentIdData,
  getStudentIdDataWithLesson
} from '../../../../lib/studenttranscript'
import style from "./transcript.module.css"

export default function Transcript({ slug }) {
  const [studentGradeList, setStudentGradeList] = useState()
  const [studentLessons, setStudentLessons] = useState()
  const [classList, setClassList] = useState([9, 10, 11, 12])
  const [lessonList, setLessonList] = useState([
    'English',
    'Math',
    'Science',
    'Social',
    'Flang',
    'PE-Art-Music',
    'Electives'
  ])
  const [english, setEnglish] = useState([])
  const [math, setMath] = useState([])
  const [science, setScience] = useState([])
  const [social, setSocial] = useState([])
  const [flang, setFlang] = useState([])
  const [partmusic, setPartmusic] = useState([])
  const [electives, setElectives] = useState([])

  console.log('partmusic', partmusic)

 function GetGradeColor(grade,lessonTitle) {
  /*
   if (!lessonTitle) {
    return { display: 'none' }
  }
*/
   let color = "#FFFFFF"
   if (grade > 0 && grade < 65) color = '#FF0000'
   if (grade > 64 && grade < 71) color = '#FFA500'
   if (grade > 70 && grade < 81) color = '#FFFF00'
   if (grade > 80 && grade < 91) color = '#32CD32'
   if (grade > 90) color = '#1E90FF'

 return { backgroundColor: color }
 }

  async function GetData() {
    const info = await getStudentIdData(slug)
    setStudentGradeList(info)
    console.log('info', info)

    setEnglish(info.filter((opt) => opt.lessonname === 'English'))
    setMath(info.filter((opt) => opt.lessonname === 'Math'))
    setScience(info.filter((opt) => opt.lessonname === 'Science'))
    setSocial(info.filter((opt) => opt.lessonname === 'Social'))
    setFlang(info.filter((opt) => opt.lessonname === 'Flang'))
    setPartmusic(info.filter((opt) => opt.lessonname === 'PE-Art-Music'))
    setElectives(info.filter((opt) => opt.lessonname === 'Electives'))

    //const lessons = await getStudentLessons(slug);
    //setStudentLessons(lessons);
  }

  useEffect(() => {
    GetData()
  }, [])

  return (
    <div className='settings-widget'>
      <div className='settings-inner-blk p-0'>
        {/* <div className='checkout-form personal-address add-course-info'> */}
          {/* <div className='personal-info-head p-2'>
            <h3>Transcript Planning</h3>
          </div> */}
          <div className='comman-space pb-0'>
            <div
              className='settings-referral-blk course-instruct-blk transcript_div'
              id='transcript_div_pdf'
            >
              {/* Instructor Users */}
              <div className='row fw-bolder fs-4 mb-4'>
                <div className='col leftCol'>Transcript Planning</div>
                {classList.map(function (data, ix) {
                  return (
                    <div className='col text-center p-0' key={ix}>
                      {data}
                    </div>
                  )
                })}
              </div>
              {english.length ? (
                <div className='row mb-4 border-bottom border-2 border-danger-subtle'>
                  <div className='col fs-4 fw-bolder leftCol'>English</div>
                  {/*}
                <div className="col">
                  {english[0].class6lesson1 + " - " + english[0].class6grade1}
                  <p></p>
                  {english[0].class6lesson2 + " - " + english[0].class6grade2}
                </div>
                <div className="col">
                  {english[0].class7lesson1 + " - " + english[0].class7grade1}
                  <p></p>
                  {english[0].class7lesson2 + " - " + english[0].class7grade2}
                </div>
                <div className="col">
                  {english[0].class8lesson1 + " - " + english[0].class8grade1}
                  <p></p>
                  {english[0].class8lesson2 + " - " + english[0].class8grade2}
                </div>
                */}
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        english[0].class9grade1,
                        english[0].class9lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {english[0].class9lesson1}
                      </span>{' '}
                      :{' '}
                      <span className={`${style.gradePart} grade_part`}>
                        {english[0].class9grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        english[0].class9grade2,
                        english[0].class9lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {english[0].class9lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {english[0].class9grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        english[0].class10grade1,
                        english[0].class10lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {english[0].class10lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {english[0].class10grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        english[0].class10grade2,
                        english[0].class10lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {english[0].class10lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {english[0].class10grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        english[0].class11grade1,
                        english[0].class11lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {english[0].class11lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {english[0].class11grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        english[0].class11grade2,
                        english[0].class11lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {english[0].class11lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {english[0].class11grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        english[0].class12grade1,
                        english[0].class12lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {english[0].class12lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {english[0].class12grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        english[0].class12grade2,
                        english[0].class12lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {english[0].class12lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {english[0].class12grade2}
                      </span>
                    </p>
                  </div>
                </div>
              ) : (
                ''
              )}
              {math.length ? (
                <div className='row mb-4 border-bottom border-2 border-danger-subtle'>
                  <div className='col fs-4 fw-bolder leftCol'>Math</div>
                  {/*}
                <div className="col">
                  {math[0].class6lesson1 + " - " + math[0].class6grade1}
                  <p></p>
                  {math[0].class6lesson2 + " - " + math[0].class6grade2}
                </div>
                <div className="col">
                  {math[0].class7lesson1 + " - " + math[0].class7grade1}
                  <p></p>
                  {math[0].class7lesson2 + " - " + math[0].class7grade2}
                </div>
                <div className="col">
                  {math[0].class8lesson1 + " - " + math[0].class8grade1}
                  <p></p>
                  {math[0].class8lesson2 + " - " + math[0].class8grade2}
                </div>
                */}
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        math[0].class9grade1,
                        math[0].class9lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {math[0].class9lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>{math[0].class9grade1}</span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        math[0].class9grade2,
                        math[0].class9lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {math[0].class9lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>{math[0].class9grade2}</span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        math[0].class10grade1,
                        math[0].class10lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {math[0].class10lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {math[0].class10grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        math[0].class10grade2,
                        math[0].class10lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {math[0].class10lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {math[0].class10grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        math[0].class11grade1,
                        math[0].class11lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {math[0].class11lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {math[0].class11grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        math[0].class11grade2,
                        math[0].class11lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {math[0].class11lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {math[0].class11grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        math[0].class12grade1,
                        math[0].class12lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {math[0].class12lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {math[0].class12grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        math[0].class12grade2,
                        math[0].class12lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {math[0].class12lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {math[0].class12grade2}
                      </span>
                    </p>
                  </div>
                </div>
              ) : (
                ''
              )}
              {science.length ? (
                <div className='row mb-4 border-bottom border-2 border-danger-subtle'>
                  <div className='col fs-4 fw-bolder leftCol'>Science</div>
                  {/*}
                <div className="col">
                  {science[0].class6lesson1 + " - " + science[0].class6grade1}
                  <p></p>
                  {science[0].class6lesson2 + " - " + science[0].class6grade2}
                </div>
                <div className="col">
                  {science[0].class7lesson1 + " - " + science[0].class7grade1}
                  <p></p>
                  {science[0].class7lesson2 + " - " + science[0].class7grade2}
                </div>
                <div className="col">
                  {science[0].class8lesson1 + " - " + science[0].class8grade1}
                  <p></p>
                  {science[0].class8lesson2 + " - " + science[0].class8grade2}
                </div>
                */}
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        science[0].class9grade1,
                        science[0].class9lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {science[0].class9lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {science[0].class9grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        science[0].class9grade2,
                        science[0].class9lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {science[0].class9lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {science[0].class9grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        science[0].class10grade1,
                        science[0].class10lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {science[0].class10lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {science[0].class10grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        science[0].class10grade2,
                        science[0].class10lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {science[0].class10lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {science[0].class10grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        science[0].class11grade1,
                        science[0].class11lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {science[0].class11lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {science[0].class11grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        science[0].class11grade2,
                        science[0].class11lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {science[0].class11lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {science[0].class11grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        science[0].class12grade1,
                        science[0].class12lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {science[0].class12lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {science[0].class12grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        science[0].class12grade2,
                        science[0].class12lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {science[0].class12lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {science[0].class12grade2}
                      </span>
                    </p>
                  </div>
                </div>
              ) : (
                ''
              )}
              {social.length ? (
                <div className='row mb-4 border-bottom border-2 border-danger-subtle'>
                  <div className='col fs-4 fw-bolder leftCol'>Social</div>
                  {/*}
                <div className="col">
                  {social[0].class6lesson1 + " - " + social[0].class6grade1}
                  <p></p>
                  {social[0].class6lesson2 + " - " + social[0].class6grade2}
                </div>
                <div className="col">
                  {social[0].class7lesson1 + " - " + social[0].class7grade1}
                  <p></p>
                  {social[0].class7lesson2 + " - " + social[0].class7grade2}
                </div>
                <div className="col">
                  {social[0].class8lesson1 + " - " + social[0].class8grade1}
                  <p></p>
                  {social[0].class8lesson2 + " - " + social[0].class8grade2}
                </div>
                */}
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        social[0].class9grade1,
                        social[0].class9lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {social[0].class9lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {social[0].class9grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        social[0].class9grade2,
                        social[0].class9lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {social[0].class9lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {social[0].class9grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        social[0].class10grade1,
                        social[0].class10lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {social[0].class10lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {social[0].class10grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        social[0].class10grade2,
                        social[0].class10lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {social[0].class10lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {social[0].class10grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        social[0].class11grade1,
                        social[0].class11lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {social[0].class11lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {social[0].class11grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        social[0].class11grade2,
                        social[0].class11lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {social[0].class11lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {social[0].class11grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        social[0].class12grade1,
                        social[0].class12lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {social[0].class12lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {social[0].class12grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        social[0].class12grade2,
                        social[0].class12lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {social[0].class12lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {social[0].class12grade2}
                      </span>
                    </p>
                  </div>
                </div>
              ) : (
                ''
              )}

              {flang.length ? (
                <div className='row mb-4 border-bottom border-2 border-danger-subtle'>
                  <div className='col fs-4 fw-bolder leftCol'>F.Lang</div>
                  {/*}
                <div className="col">
                  {flang[0].class6lesson1 + " - " + flang[0].class6grade1}
                  <p></p>
                  {flang[0].class6lesson2 + " - " + flang[0].class6grade2}
                </div>
                <div className="col">
                  {flang[0].class7lesson1 + " - " + flang[0].class7grade1}
                  <p></p>
                  {flang[0].class7lesson2 + " - " + flang[0].class7grade2}
                </div>
                <div className="col">
                  {flang[0].class8lesson1 + " - " + flang[0].class8grade1}
                  <p></p>
                  {flang[0].class8lesson2 + " - " + flang[0].class8grade2}
                </div>
                */}
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        flang[0].class9grade1,
                        flang[0].class9lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {flang[0].class9lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {flang[0].class9grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        flang[0].class9grade2,
                        flang[0].class9lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {flang[0].class9lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {flang[0].class9grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        flang[0].class10grade1,
                        flang[0].class10lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {flang[0].class10lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {flang[0].class10grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        flang[0].class10grade2,
                        flang[0].class10lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {flang[0].class10lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {flang[0].class10grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        flang[0].class11grade1,
                        flang[0].class11lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {flang[0].class11lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {flang[0].class11grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        flang[0].class11grade2,
                        flang[0].class11lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {flang[0].class11lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {flang[0].class11grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        flang[0].class12grade1,
                        flang[0].class12lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {flang[0].class12lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {flang[0].class12grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        flang[0].class12grade2,
                        flang[0].class12lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {flang[0].class12lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {flang[0].class12grade2}
                      </span>
                    </p>
                  </div>
                </div>
              ) : (
                ''
              )}
              {partmusic.length ? (
                <div className='row mb-4 border-bottom border-2 border-danger-subtle'>
                  <div className='col fs-4 fw-bolder leftCol'>PE-Art-Music</div>
                  {/*}
                <div className="col">
                  {partmusic[0].class6lesson1 + " - " + partmusic[0].class6grade1}
                  <p></p>
                  {partmusic[0].class6lesson2 + " - " + partmusic[0].class6grade2}
                </div>
                <div className="col">
                  {partmusic[0].class7lesson1 + " - " + partmusic[0].class7grade1}
                  <p></p>
                  {partmusic[0].class7lesson2 + " - " + partmusic[0].class7grade2}
                </div>
                <div className="col">
                  {partmusic[0].class8lesson1 + " - " + partmusic[0].class8grade1}
                  <p></p>
                  {partmusic[0].class8lesson2 + " - " + partmusic[0].class8grade2}
                </div>
                */}
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        partmusic[0].class9grade1,
                        partmusic[0].class9lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {partmusic[0].class9lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {partmusic[0].class9grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        partmusic[0].class9grade2,
                        partmusic[0].class9lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {partmusic[0].class9lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {partmusic[0].class9grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        partmusic[0].class10grade1,
                        partmusic[0].class10lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {partmusic[0].class10lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {partmusic[0].class10grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        partmusic[0].class10grade2,
                        partmusic[0].class10lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {partmusic[0].class10lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {partmusic[0].class10grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        partmusic[0].class11grade1,
                        partmusic[0].class11lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {partmusic[0].class11lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {partmusic[0].class11grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        partmusic[0].class11grade2,
                        partmusic[0].class11lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {partmusic[0].class11lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {partmusic[0].class11grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        partmusic[0].class12grade1,
                        partmusic[0].class12lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {partmusic[0].class12lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {partmusic[0].class12grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        partmusic[0].class12grade2,
                        partmusic[0].class12lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {partmusic[0].class12lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {partmusic[0].class12grade2}
                      </span>
                    </p>
                  </div>
                </div>
              ) : (
                ''
              )}

              {electives.length ? (
                <div className='row mb-4 border-bottom border-2 border-danger-subtle'>
                  <div className='col fs-4 fw-bolder leftCol'>Electives</div>
                  {/*}
                <div className="col">
                  {electives[0].class6lesson1 + " - " + electives[0].class6grade1}
                  <p></p>
                  {electives[0].class6lesson2 + " - " + electives[0].class6grade2}
                </div>
                <div className="col">
                  {electives[0].class7lesson1 + " - " + electives[0].class7grade1}
                  <p></p>
                  {electives[0].class7lesson2 + " - " + electives[0].class7grade2}
                </div>
                <div className="col">
                  {electives[0].class8lesson1 + " - " + electives[0].class8grade1}
                  <p></p>
                  {electives[0].class8lesson2 + " - " + electives[0].class8grade2}
                </div>
                */}
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        electives[0].class9grade1,
                        electives[0].class9lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {electives[0].class9lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {electives[0].class9grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        electives[0].class9grade2,
                        electives[0].class9lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {electives[0].class9lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {electives[0].class9grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        electives[0].class10grade1,
                        electives[0].class10lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {electives[0].class10lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {electives[0].class10grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        electives[0].class10grade2,
                        electives[0].class10lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {electives[0].class10lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {electives[0].class10grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        electives[0].class11grade1,
                        electives[0].class11lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {electives[0].class11lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {electives[0].class11grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        electives[0].class11grade2,
                        electives[0].class11lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {electives[0].class11lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {electives[0].class11grade2}
                      </span>
                    </p>
                  </div>
                  <div className='col p-0 singleCell'>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        electives[0].class12grade1,
                        electives[0].class12lesson1
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {electives[0].class12lesson1}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {electives[0].class12grade1}
                      </span>
                    </p>
                    <p
                      className='grade_column'
                      style={GetGradeColor(
                        electives[0].class12grade2,
                        electives[0].class12lesson2
                      )}
                    >
                      <span className={`${style.lessonTitle} lesson_title`}>
                        {electives[0].class12lesson2}
                      </span>{' '}
                      :{' '}
                      <span className='grade_part'>
                        {electives[0].class12grade2}
                      </span>
                    </p>
                  </div>
                </div>
              ) : (
                ''
              )}
              {/* Instructor List */}
            </div>
          </div>
        </div>
      {/* </div> */}
    </div>
  )
}
